<template>
	<div class="p-5">
		<div class="grid grid-cols-5 gap-5 mb-3">
			<div class="cols-span-1 border rounded border-red-500 bg-red-200 p-5">
				<div class="text-lg font-semibold mb-1.5">Purchase Plan</div>
				<div class="text-3xl font-semibold">{{ Intl.NumberFormat().format(statistics?.demandForecast) }}</div>
			</div>
			<div class="cols-span-1 border rounded border-blue-500 bg-blue-200 p-5">
				<div class="text-lg font-semibold mb-1.5">Purchase bulan ini</div>
				<div class="text-3xl font-semibold">{{ Intl.NumberFormat().format(statistics?.purchaseThisMonth) }}</div>
			</div>
			<div class="cols-span-1 border rounded border-yellow-500 bg-yellow-200 p-5">
				<div class="text-lg font-semibold mb-1.5">Sedang di produksi</div>
				<div class="text-3xl font-semibold">{{ Intl.NumberFormat().format(statistics?.purchase) }}</div>
			</div>
			<div class="cols-span-1 border rounded border-green-500 bg-green-200 p-5">
				<div class="text-lg font-semibold mb-1.5">Total Barang Masuk</div>
				<div class="text-3xl font-semibold">{{ Intl.NumberFormat().format(statistics?.receipt) }}</div>
			</div>
			<div class="cols-span-1 border rounded border-purple-500 bg-purple-200 p-5">
				<div class="text-lg font-semibold mb-1.5">Total Barang Terjual</div>
				<div class="text-3xl font-semibold">{{ Intl.NumberFormat().format(statistics?.sales) }}</div>
			</div>
		</div>
		<div class="w-full rounded overflow-hidden">
			<table class="w-full">
				<thead>
					<tr>
						<th class="h-11 px-3 bg-gray-900 text-gray-50">Supplier</th>
						<th class="h-11 px-3 bg-gray-900 text-gray-50">Tanggal Mulai</th>
						<th class="h-11 px-3 bg-gray-900 text-gray-50 text-right">Total Invoice</th>
						<th class="h-11 px-3 bg-gray-900 text-gray-50 text-right">Sedang Produksi</th>
						<th class="h-11 px-3 bg-gray-900 text-gray-50 text-right">Barang Masuk</th>
					</tr>
				</thead>
				<tbody v-if="isLoading" class="divide-y">
					<tr v-for="i in 20" :key="i">
						<td class="px-3 py-2.5 animate-pulse"><div class="h-4 w-full rounded bg-gray-300"></div></td>
						<td class="px-3 py-2.5 animate-pulse"><div class="h-4 w-full rounded bg-gray-300"></div></td>
						<td class="px-3 py-2.5 animate-pulse"><div class="h-4 w-full rounded bg-gray-300"></div></td>
						<td class="px-3 py-2.5 animate-pulse"><div class="h-4 w-full rounded bg-gray-300"></div></td>
						<td class="px-3 py-2.5 animate-pulse"><div class="h-4 w-full rounded bg-gray-300"></div></td>
					</tr>
				</tbody>
				<tbody v-else class="divide-y">
					<tr v-for="(purchase, i) in purchases" :key="i">
						<td class="px-3 py-2.5">{{ purchase?.supplier }}</td>
						<td class="px-3 py-2.5">{{ formatDate(purchase?.invoiceDate) }}</td>
						<td class="px-3 py-2.5 text-right">{{ purchase?.invoiceCount }}</td>
						<td class="px-3 py-2.5 text-right">{{ Intl.NumberFormat().format(purchase?.sedangProduksi) }}</td>
						<td class="px-3 py-2.5 text-right">{{ Intl.NumberFormat().format(purchase?.barangMasuk) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';

const isLoading = ref(false)
const statistics = ref('')
const purchases = ref([])

const getData = async () => {
	isLoading.value = true
	const res = await axios.get('/stock-order/dashboard')
	statistics.value = res.data
	const purchase = await axios.get('/stock-order/purchase')
	purchases.value = purchase.data
	isLoading.value = false
}

const formatDate = (e) => {
	if(!e) return "-"
	const date = new Date(e)
	let d = date.getDate()
	let m = date.getMonth() + 1
	let y = date.getFullYear()
	return `${d}/${m}/${y}`
}

onMounted(() => {
	getData()
})
</script>